module.exports = {"id":"artist-john_doe","slug":"john-doe","name":"John Doe"}


//////////////////
// WEBPACK FOOTER
// ./src/store/data/artists/artist-john_doe.json
// module id = ./src/store/data/artists/artist-john_doe.json
// module chunks = 2